<template>
  <v-app class="grey lighten-3">
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-container grid-list-md>
          <v-card v-if="isDataLoaded">
            <v-card-title class="project">
              <div class="white--text headline">
                <span>Project Settings</span>
              </div>
            </v-card-title>
            <!-- {{ indexData.projectData }} -->
            <assigned-agent-group-to-project
              v-if="indexData.projectData.dasher_category_id == 3"
              :project_id="indexData.projectData.id"
            ></assigned-agent-group-to-project>
            <project-filtering-preview
              v-if="indexData.projectData.dasher_category_id == 1"
              :project_data="indexData.projectData"
            ></project-filtering-preview>
            <assigned-teams-to-project
              v-if="indexData.projectData.dasher_category_id == 2"
              :project_id="indexData.projectData.id"
            ></assigned-teams-to-project>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import {
  AssignedAgentGroupToProject,
  AssignedTeamsToProject,
  ProjectFilteringPreview,
} from "@/components/index";
import router from "@/router";

export default {
  components: {
    AssignedAgentGroupToProject,
    AssignedTeamsToProject,
    ProjectFilteringPreview,
  },
  data: () => ({
    apiUrl: "project-info-details",
    clicked: false,
    q_blank_status: false,
    teams: [],
    sl: 1,

    loading: false,
    editedIndex: -1,
    img_op: null,
    ProjectFilterBasicData: {
      ProjectFilteringParameter: [],
      districts: [],
      divisions: [],
      educations: [],
      genders: [],
      income: [],
      operators: [],
      professions: [],
      upazila: [],
    },
    editedItem: {
      projectData: [
        {
          // project data
          name: "",
          project_type_id: "",
          details: "",
          begin_date: "",
          end_date: "",
          duration: "",
          project_language: "",
          total_budget_amount: 0,
          per_survey_cost: 0,
          number_of_response: 0,
        },
      ],
      projectInfo: {
        // project data
        name: "",
        project_type_id: "",
        details: "",
        begin_date: "",
        end_date: "",
        duration: "",
        project_language: "",
        total_budget_amount: 0,
        per_survey_cost: 0,
        number_of_response: 0,
      },

      questions: [
        {
          question: "",
          ui_category_id: "",
          required_optional: "",
          multiple_answer: "",
          instruction: "",
          description: "",
          boolean1: false,
          boolean2: false,
          date_time: "date & time",
          radios: [
            {
              name: "option1",
            },
          ],
          checkboxes: [
            {
              name: "option1",
            },
          ],
          dropdowns: [
            {
              name: "option1",
            },
          ],
          images: [
            {
              url: "",
            },
          ],
          range: {
            min: "",
            max: "",
          },
          slider: {
            min: "",
            max: "",
            interval: "",
          },
          starRating: {
            min: "",
            max: "",
            interval: "",
          },
          contactInfo: {
            first_name: true,
            middle_name: true,
            last_name: false,
            phone: true,
            email: true,
            address: false,
          },
        },
      ],
      preQuestions: [],
      teamToProjectData: [],
      filter_data: [],

      locationBased: [],
      filter_skip: false,
      available_dasher: null,
    },
    data: {
      project_id: null,
      questions: [],
      preQuestions: [],
    },
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    q_validate: function () {
      this.blank_check();
      return "Question should not be blank";
    },

    isDataLoaded: function () {
      this.loadData();
      if (this.indexData.projectData) {
        return true;
      } else {
        return false;
      }
    },

    check_submit: function () {
      if (this.q_blank_status == true) {
        return "contains error";
      } else {
        return "SUBMIT";
      }
    },
  },

  created() {
    this.initialize();
  },
  methods: {
    // initialize editing data
    initialize() {
      var project_id = this.$route.params.id;
      this.data.project_id = project_id;
      this.$store.dispatch("indexData", [this.apiUrl, project_id]);
    },
    loadData() {
      if (this.indexData.projectData) {
        if (this.indexData.projectData.dasher_category_id == 2) {
          this.editedItem.teamToProjectData = JSON.parse(
            this.indexData.projectData.assigned_team_to_project
          );
        }

        this.editedItem.projectInfo.project_type_id =
          this.indexData.projectData.project_type_id;
        this.editedItem.projectData = this.indexData.projectData;
        this.editedItem.filter_skip = this.indexData.projectData.filter_skip;
        if (
          this.editedItem.projectInfo.project_type_id == 1 &&
          this.editedItem.filter_skip != 1
        ) {
          var filteringData = JSON.parse(
            this.indexData.projectData.filtering_parameters
          );
          this.ProjectFilterBasicData.ProjectFilteringParameter =
            this.indexData.ProjectFilteringParameter;
          this.ProjectFilterBasicData.districts = this.indexData.districts;
          this.ProjectFilterBasicData.divisions = this.indexData.divisions;
          this.ProjectFilterBasicData.educations = this.indexData.educations;
          this.ProjectFilterBasicData.genders = this.indexData.genders;
          this.ProjectFilterBasicData.income = this.indexData.income;
          this.ProjectFilterBasicData.operators = this.indexData.operators;
          this.ProjectFilterBasicData.professions = this.indexData.professions;
          this.ProjectFilterBasicData.upazila = this.indexData.upazila;
          this.editedItem.filter_data = filteringData;
        }

        // var questionData = JSON.parse(
        //   this.indexData.projectData.project_question_json
        // );
        var preQuestionData = JSON.parse(
          this.indexData.projectData.pre_survey_question_json
        );
        // this.editedItem.questions = questionData
        //   ? questionData.questions
        //   : [];
        if (this.indexData.projectData.has_pre_survey) {
          this.editedItem.preQuestions = preQuestionData
            ? preQuestionData.questions
            : [];
        }

        // console.log(this.editedItem.questions);
        this.teams = this.indexData.teams;

        // console.log( this.indexData.questions);
        return true;
      }
      return false;
    },
    blank_check() {
      return (this.q_blank_status = true);
    },

    getProjectLanguage(project_language) {
      if (project_language == 1) {
        return "English";
      } else if (project_language == 2) {
        return "Bangla";
      } else {
        return "English & Bangla both";
      }
    },
    back() {
      if (this.editedItem.projectData.project_type_id != 2) {
        router.push("/budget");
      } else {
        router.push("/budget2");
      }
    },

    submit() {
      if (
        this.editedItem.projectInfo.project_type_id == 2 &&
        this.indexData.numberOfResponse < 1
      ) {
        alert("Sorry! Survey locations could not be empty");
      } else {
        this.data.questions = this.editedItem.questions;
        this.data.preQuestions = this.editedItem.preQuestions;
        // this.data.project_id = 0;
        this.$store.dispatch("projectSubmission", [
          "project-submit",
          this.data,
        ]);
      }
      this.clicked = true;
    },
  },
};
</script>

<style scoped>
.ck.ck-editor__editable:not(.ck-editor__nested-editable) {
  border-radius: 0;
  min-height: 100px;
}
.ck-content {
  min-height: 100px;
}
.icon {
  background: #f66;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 20px;
  cursor: pointer;
}
.button {
  font-size: 16px;
  background: #f66;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.text_color {
  color: white;
}
.project {
  background: #f66;
}
</style>
